module.exports = __webpack_public_path__ + "img/1.15.C.b13556e6.png";